var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-settings-sliders",
    opacity: 0.5,
    clipPath: "url(#clip0_7389_16722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.87674 8.90762H7.00623C8.01863 12.6326 11.859 14.8316 15.5839 13.8192C17.9763 13.1689 19.8452 11.3 20.4955 8.90762H43.1226C44.158 8.90762 44.9974 8.06826 44.9974 7.03283C44.9974 5.99741 44.158 5.15805 43.1226 5.15805H20.4955C19.4831 1.433 15.6427 -0.76598 11.9178 0.246419C9.52536 0.896657 7.65646 2.76555 7.00623 5.15796H1.87674C0.841313 5.15796 0.00195312 5.99732 0.00195312 7.03274C0.00195312 8.06817 0.841313 8.90762 1.87674 8.90762Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.1226 20.6256H37.9931C36.9827 16.9012 33.1445 14.701 29.4201 15.7113C27.0257 16.3608 25.1552 18.2312 24.5057 20.6256H1.87674C0.841313 20.6256 0.00195312 21.465 0.00195312 22.5004C0.00195312 23.5358 0.841313 24.3752 1.87674 24.3752H24.5057C25.5161 28.0996 29.3543 30.2998 33.0788 29.2896C35.4731 28.64 37.3436 26.7696 37.9931 24.3752H43.1226C44.158 24.3752 44.9974 23.5358 44.9974 22.5004C44.9974 21.465 44.158 20.6256 43.1226 20.6256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M43.1226 36.0925H20.4955C19.4831 32.3676 15.6427 30.1686 11.9178 31.181C9.52536 31.8312 7.65646 33.7001 7.00623 36.0925H1.87674C0.841313 36.0925 0.00195312 36.9319 0.00195312 37.9673C0.00195312 39.0027 0.841313 39.8421 1.87674 39.8421H7.00623C8.01863 43.567 11.859 45.766 15.5839 44.7536C17.9763 44.1034 19.8452 42.2345 20.4955 39.8421H43.1226C44.158 39.8421 44.9974 39.0027 44.9974 37.9673C44.9974 36.9319 44.158 36.0925 43.1226 36.0925Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7389_16722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingEdit);
export default __webpack_public_path__ + "static/media/setting-edit.ca577257ba91a84de7e98218f969da77.svg";
export { ForwardRef as ReactComponent };